import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';
import { CardTitle } from '../../components/CardTitle';

import { allProductsState } from '../../recoil/atoms';
import { assetPathFn } from '../../util';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import styles from './BoldnessTankLanderMobile.module.scss';
import { useLanderControls } from '../LanderContext';
import { ProductReviewQuote } from '../components/ProductReviewQuote';

export const BoldnessTankLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero heroImage={'mobile-boldness-tank-lander-top-hero-1.jpg'} title={'Boldness Tank'} subTitle={'The world’s most powerful sculpting tank.'}>
          <HeroCallout
            orderIndex={0}
            label={<>Underwire-free lift</>}
            color="black"
            labelColor="black"
            inlineStyles={{
              mobile: {
                right: `56%`,
                top: `48%`,
                flexDirection: 'row',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            color="black"
            labelColor="black"
            titleStyles={{ lineHeight: '22px' }}
            label={
              <>
                Serious waist
                <br /> contouring
              </>
            }
            inlineStyles={{
              mobile: {
                left: `64%`,
                top: `59%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            color="black"
            labelColor="black"
            label={<>Bonded compression</>}
            inlineStyles={{
              mobile: {
                left: `3%`,
                top: `74%`,
                flexDirection: 'row',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-bb-desktop-1.jpg',
              title: 'Extreme sculpting',
              description: 'Strong, bonded panels and 360° boning provide maximum body sculpting.',
            },
            {
              imgName: 'feature-bb-desktop-2.jpg',
              title: 'Ditch your bra',
              description: 'Ultra supportive, molded bust support provides lift without underwire.',
            },
            {
              imgName: 'feature-bb-desktop-3.jpg',
              title: 'Stylish and supportive',
              description: 'Smart details and flattering features make a confidence-boosting fashion statement.',
            },
          ]}
        />
        <CardTitle text="Innovation you can see." style={{ paddingTop: 0 }} type="capital" />
        <div className={styles.comparison}>
          <img src={assetPathFn('boldness-bodysuit-before-after.jpg')} alt="comparison" />
          <div>
            <div>competitor</div>
            <div>
              boldness <br />
              tank
            </div>
          </div>
        </div>
        <ShopNowCardSection onClick={scrollToProductSection} />
        <ProductReviewQuote
          backgroundColor="#F1F2F2"
          rightPanelMaxWidth={'720px'}
          quotes={[
            {
              quoteText: `“This is a magic tank top. It instantly turns me into a curvy goddess in a way I did not think was possible. It’s like instant confidence.”`,
              author: '- Kara B.',
            },
            {
              quoteText: `“This is a seriously intense tank, but it’s surprisingly comfortable when it’s on. Sometimes you want to turn the volume up to 100, and this is the top to do it!”`,
              author: '- Janise',
            },
            {
              quoteText: `“I gave this a try because Honeylove has a good return policy not knowing what to expect - but you couldn’t wrestle this thing out of my hands if you tried. I have NEVER felt more snatched in my life and it is all because of this phenomenal tank.”`,
              author: '- Bailey W.',
            },
          ]}
          imgName="bt-quote-mobile-1.jpg"
        />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.BoldnessTank]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default BoldnessTankLanderMobile;
